import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { alpha } from '@mui/material/styles';

import Fields from './Fields';

const JobMonitorCard = ({ data, onDragStart, getServiceById, onClick, isMobile }) => {
  return (
    <Box
      sx={{
        backgroundColor: alpha(data.s_statusColor, 0.2),
        border: '2px solid #8e8e8e',
        marginBottom: '0.75rem',
        padding: '0.5rem',
        borderRadius: '0.375rem',
        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
      }}
      onDragStart={(event) => onDragStart(event, data)}
      draggable
      onClick={() => onClick && onClick(data)}
    >
      <div className="flex justify-between w-full flex-wrap">
        <div className="flex items-center gap-3 flex-wrap">
          <Typography sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{data.s_workingNumber}</Typography>
          <Chip label={data?.s_statusName} size="small" sx={{ backgroundColor: data.s_statusColor }} />
        </div>

        {!isMobile && (
          <Box
            sx={{
              backgroundColor: 'white',
              color: 'black',
              px: '0.5rem',
              paddingTop: '0.4rem',
              paddingBottom: '0.375rem',
              borderRadius: '0.25rem',
              cursor: 'pointer',
            }}
          >
            <RemoveRedEyeIcon sx={{ fontSize: '1.4rem' }} onClick={() => getServiceById(data.s_id)} />
          </Box>
        )}
      </div>
      <Fields data={data} />
    </Box>
  );
};

export default JobMonitorCard;
